import { FieldViewModel, ExplorerContext, LayerViewModel, map } from "../omnia"

export import isFieldViewModel = omnia.fields.isFieldViewModel

export interface ContextMenuArguments {
    tooltip: map.IMapTooltip,
    context: ExplorerContext,
    field: FieldViewModel,
    layer: LayerViewModel
}
